import React from 'react';
import { Flame } from 'lucide-react';
interface StreakBadgeProps {
  streak: number;
}
export const StreakBadge: React.FC<StreakBadgeProps> = ({
  streak
}) => {
  if (streak === 0) return null;
  return <div className="flex items-center space-x-1 text-amber-500 bg-amber-50 px-2 py-1 rounded-full text-xs font-medium" data-id="element-45">
      <Flame size={14} className="animate-pulse" data-id="element-46" />
      <span data-id="element-47">
        {streak} {streak === 1 ? 'day' : 'days'}
      </span>
    </div>;
};